import styled from 'styled-components';

export const SCOPE_FORM_LABEL_CLASS = 'scope-form-label';
export const LabelWrapper = styled.div.attrs({
  className: SCOPE_FORM_LABEL_CLASS,
})`
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 5px;
  min-width: 50px;
  font-family: var(--font-family, Inter, sans-serif);
  font-size: var(--font-size-small, 12px);
  font-weight: 400;
  line-height: 18px;
  color: var(--color-text-muted, #5a6a6a) !important;

  .label-text {
    font: inherit;
    color: inherit !important;
  }
`;

/** Light grey "(optional)" suffix for form labels — matches edit-friendly-name / column drawers. */
export const LabelOptionalSuffix = styled.span.attrs({
  className: 'scope-form-label-optional',
})`
  font-size: 12px;
  color: var(--color-text-muted, #5a6a6a) !important;
  font-weight: 400;
  opacity: 0.85;
`;
